import { useIntl } from "react-intl";

export function getDir(locale: string): "rtl" | "ltr" {
  return locale === "ar" ? "rtl" : "ltr";
}

export function useLocaleInfo() {
  const intl = useIntl();

  const dir = getDir(intl.locale);

  return { locale: intl.locale, dir };
}
